export { highlightText } from './highlight';
export { validateDescriptionLength, getDescriptionTextLength, getTextFromHtml } from './validation';
export { stripHtmlTags, extractFirstHtmlBlock, type HtmlBlockExtractionResult } from './htmlBlock';
export { getTextLengthFromHtml } from './htmlLength';

export function matchesKeywordFilter(query: string, ...haystacks: (string | number | undefined | null)[]): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return haystacks.some((h) =>
    String(h ?? '')
      .toLowerCase()
      .includes(q)
  );
}
